var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-4 q-pa-sm" },
      [
        _c(
          "q-list",
          { attrs: { separator: "", multiline: "", dense: "" } },
          [
            _c(
              "q-item",
              [
                _c("q-item-side", {
                  attrs: { icon: "home", color: "primary" }
                }),
                _c(
                  "q-item-main",
                  [
                    _c(
                      "q-item-tile",
                      {
                        staticClass: "cursor-pointer",
                        attrs: { label: "" },
                        nativeOn: {
                          click: function($event) {
                            return _vm.clickHome()
                          }
                        }
                      },
                      [
                        _vm._v("Widok domyślny\n            "),
                        _c("q-popover", [
                          _vm._v(
                            _vm._s(_vm.defaultlat) +
                              " : " +
                              _vm._s(_vm.defaultlon) +
                              "\n            "
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._l(_vm.markers, function(item) {
              return _c(
                "q-item",
                { key: item._oid },
                [
                  _c("q-item-side", {
                    attrs: { icon: "room", color: "primary" }
                  }),
                  _c(
                    "q-item-main",
                    [
                      _c(
                        "q-item-tile",
                        {
                          staticClass: "cursor-pointer",
                          attrs: { label: "" },
                          nativeOn: {
                            click: function($event) {
                              return _vm.clickMarker(item)
                            },
                            dblclick: function($event) {
                              return _vm.dblClickMarker(item)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(item.title) +
                              "\n            "
                          ),
                          _c("q-popover", [
                            _vm._v(
                              _vm._s(item.lat) +
                                " : " +
                                _vm._s(item.lng) +
                                "\n            "
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("q-item-side", {
                    staticClass: "cursor-pointer",
                    attrs: { right: "", icon: "close", color: "red" },
                    nativeOn: {
                      click: function($event) {
                        return _vm.deleteMarker(item)
                      }
                    }
                  })
                ],
                1
              )
            })
          ],
          2
        )
      ],
      1
    ),
    _c("div", { staticClass: "col q-pa-sm" }, [
      _c("div", { ref: "mymap", staticClass: "leaflet-map" })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }